import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': 'K8wNqnaJvG1SvMRmQcBeA9PM9FQ23AHt4r8zbxZh'
  })
};


@Injectable({
  providedIn: 'root'
})
export class OfflineactivationService {



  constructor(private http: HttpClient) { }

  // K8wNqnaJvG1SvMRmQcBeA9PM9FQ23AHt4r8zbxZh
  activateInstance(teamid: string, instanceid: string, secret: string, force?:boolean){
    console.log(`Sending request: team = ${teamid}, instanceid = ${instanceid}, secret = ${secret} `)
    if (force)
      return this.http.post(`https://connect.xeotek.link/team/${teamid}/instance`,{"instance":instanceid,  "secret":secret}, httpOptions);

    return this.http.post(`https://connect.xeotek.link/team/${teamid}/details`,{"instance":instanceid,  "secret":secret}, httpOptions);
  }
}
